import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCapIcon, MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { degreeCategories } from '../data/degrees';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const popularPrograms = [{
    name: 'Business',
    path: '/degrees/business'
  }, {
    name: 'Computer Science',
    path: '/degrees/computer-science'
  }, {
    name: 'Nursing',
    path: '/degrees/healthcare'
  }, {
    name: 'Criminal Justice',
    path: '/degrees/criminal-justice'
  }, {
    name: 'Psychology',
    path: '/degrees/psychology'
  }];
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="flex justify-between items-center h-20" data-id="element-159">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-160">
            <Link to="/" className="flex items-center" data-id="element-161">
              <img src="https://cdn.magicpatterns.com/uploads/t42RRFzoQcZTQwKva1oBHJ/OnlineCollegeGuide_logo_design_1.webp" alt="OnlineCollegeGuide - Find Your Path Forward" className="h-12 sm:h-14 w-auto object-contain" data-id="element-162" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-163">
            <div className="relative" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)} data-id="element-164">
              <button className="flex items-center text-gray-700 hover:text-navy font-medium py-2 transition-colors" data-id="element-165">
                Browse Degrees
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-166" />
              </button>

              {/* Dropdown Menu */}
              {isDropdownOpen && <div className="absolute top-full left-0 w-64 bg-white shadow-lg rounded-b-lg border border-gray-100 py-2 z-50" data-id="element-167">
                  {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-4 py-2 text-sm text-gray-700 hover:bg-light hover:text-navy hover:font-medium" onClick={() => setIsDropdownOpen(false)} data-id="element-168">
                      {category.name}
                    </Link>)}
                </div>}
            </div>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-169">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-navy hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-navy" data-id="element-170">
              <span className="sr-only" data-id="element-171">Open main menu</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-172" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-173" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-b border-gray-200 shadow-inner" data-id="element-174">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-175">
            <div className="px-3 py-2 text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-176">
              All Degree Categories
            </div>
            {degreeCategories.map(category => <Link key={category.id} to={`/degrees/${category.id}`} className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-navy hover:bg-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-177">
                {category.name}
              </Link>)}
          </div>
        </div>}
    </header>;
}